import { atom, atomFamily, selector } from 'recoil'
import { userStateSelector } from '/src/hooks/useUser'
import { getRequest, postRequest } from '/src/httpClient'
import { isBrowser } from '/src/util'

export const productVariationSelectionState = atom({
  key: 'productVariationSelectionState',
  default: false
})

const getFavourites = async () => {
  return await getRequest('/api/user/favourites', new AbortController())
}

const updateFavourites = async (favourites) => {
  return await postRequest('/api/user/favourites/update', { favourites })
}

export const productVariationFavouritesState = atom({
  key: 'productVariationFavouritesState',
  default: selector({
    key: 'productVariationFavouritesState/default',
    get: ({ get }) => {
      if (!isBrowser) return []

      const user = get(userStateSelector)
      if (!user) return []

      const result = getFavourites()
      return result ? result : []
    }
  })
})

export const productVariationFavouritesQuery = selector({
  key: 'productVariationFavouritesQuery',
  get: ({ get }) => {
    const user = get(userStateSelector)
    if (!user) return []

    return get(productVariationFavouritesState)
  },
  set: ({ get, set }, newValue) => {
    const user = get(userStateSelector)
    if (!user) return []

    updateFavourites(newValue)
    set(productVariationFavouritesState, newValue)
  }
})

/*export const productVariationFavouritesState = atomFamily({
  key: 'productVariationFavouritesState',
  default: async ({ userId }) => {
    if (!isBrowser) return []

    const result = await getFavourites()
    return result ? result : []
  }
})

export const productVariationFavouritesQuery = selectorFamily({
  key: 'productVariationFavouritesQuery',
  get: () => async ({ get }) => {
    const user = get(userStateSelector)
    if (!user) return []

    return get(productVariationFavouritesState({ userId: user.uid }))
  },
  set: () => ({ get, set }, newValue) => {
    const user = get(userStateSelector)
    if (!user) return []

    updateFavourites(newValue)
    set(productVariationFavouritesState({ userId: user.uid }), newValue)
  }
})*/
